module.exports = __webpack_public_path__ + "img/guide-suggestion.8783ad9a.png";